import type { AppConfigInput } from '@nuxt/schema'

export default {
  pagination: {
    slots: {
      root: '',
      list: 'flex items-center gap-6',
      ellipsis: 'pointer-events-none',
      label: 'min-w-5 text-center',
      first: 'hidden!',
      prev: '',
      item: 'px-0!',
      next: '',
      last: 'hidden!',
    },
  },
} as AppConfigInput['ui']
